import { TbReportSearch } from "react-icons/tb";
import { AiFillSignal } from "react-icons/ai";
import { AiFillHome } from "react-icons/ai";
import { BiUserPlus } from "react-icons/bi";
import { HiClipboardDocumentList } from "react-icons/hi2";
import { IoNotificationsCircleSharp } from "react-icons/io5";
import { TbTableOptions } from "react-icons/tb";
import { Link, useNavigate } from "react-router-dom";
import "./NarvBarLeft.css";

const NavbarLeft = () => {
  const navigate = useNavigate();

  const handleClearData = () => {
    sessionStorage.removeItem("reportData");
  };

  const handleData = () => {
    const storedData = sessionStorage.getItem("reportData");
    if (storedData) {
      const data = JSON.parse(storedData);
      navigate("/detalle-ingresos-egresos", { state: { data } });
    }
  };

  return (
    <div className="allheaderleft">
      <Link style={{ textDecoration: "none" }} to="/inicio">
        <div className="button-index-left" onClick={handleClearData}>
          <div className="container-text-icons">
            <AiFillHome className="icon-button-left" />
            <p className="text-button-left-in">Home</p>
          </div>
        </div>
      </Link>
      <Link style={{ textDecoration: "none" }} to="/informe">
        <div className="button-index-left">
          <div className="container-text-icons">
            <TbReportSearch className="icon-button-left" />
            <p className="text-button-left-in">Informe</p>
          </div>
        </div>
      </Link>
      <Link style={{ textDecoration: "none" }} to="/detailMDR">
        <div className="button-index-left">
          <div className="container-text-icons">
            <AiFillSignal className="icon-button-left" />
            <p className="text-button-left">Matriz de Riesgo</p>
          </div>
        </div>
      </Link>
      <Link style={{ textDecoration: "none" }} to="/crear-relacion">
        <div className="button-index-left">
          <div className="container-text-icons">
            <BiUserPlus className="icon-button-left" />
            <p className="text-button-left">
              Crear <br /> Relación
            </p>
          </div>
        </div>
      </Link>
      <Link style={{ textDecoration: "none" }} to="/alertas">
        <div className="button-index-left">
          <div className="container-text-icons">
            <IoNotificationsCircleSharp className="icon-button-left" />
            <p className="text-button-left">Alertas</p>
          </div>
        </div>
      </Link>
      <Link style={{ textDecoration: "none" }} to="/edit-matriz">
        <div className="button-index-left">
          <div className="container-text-icons">
            <TbTableOptions className="icon-button-left" />
            <p className="text-button-left">Variables de Matriz</p>
          </div>
        </div>
      </Link>
      <Link style={{ textDecoration: "none" }} to="/detalle-ingresos-egresos">
        <div className="button-index-left" onClick={handleData}>
          <div className="container-text-icons">
            <HiClipboardDocumentList className="icon-button-left" />
            <p className="text-button-left">
              Pagos <br /> y Cobros
            </p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default NavbarLeft;
